import { useQuery } from "@tanstack/react-query";
import { getTargetareNomenclatoare } from "@/api/endpoints/targetareDate";
import { queryKeys } from "@/lib/queryClient";

export function useGetTargetareNomenclatoare() {
  return useQuery({
    queryKey: queryKeys.targetare.nomenclatoare(),
    queryFn: getTargetareNomenclatoare,
    select: (response) => response.data,
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });
}
